export const RECIPES = {
  "Risikogruppe I": {
    pair:   "Ein Paar stützende Einlagen mit Längs- und Quergewölbestütze, Supinationskeil bds., Weichbettung langsohlig bds.",
    single: "Eine stützende Einlage mit Längs- und Quergewölbestütze, Supinationskeil, Weichbettung langsohlig.",
  },
  "Risikogruppe IIa": {
    pair:   "Ein Paar Weichpolsterbettungseinlagen, elastisch, druckumverteilend.",
    single: "Eine Weichpolsterbettungseinlage, elastisch, druckumverteilend.",
  },
  "Risikogruppe IIb": {
    pair:   "Ein Paar Spezialschuhe bei Diabetischem Fußsyndrom mit diabetesadaptierter Fußbettung.",
    single: "Ein Spezialschuh bei Diabetischem Fußsyndrom mit diabetesadaptierter Fußbettung.",
  },
  "Risikogruppe IIb (Praeulzerative)": {
    pair:   "Ein Paar Spezialschuhe bei Diabetischem Fußsyndrom mit diabetesadaptierter Fußbettung.",
    single: "Ein Spezialschuh bei Diabetischem Fußsyndrom mit diabetesadaptierter Fußbettung.",
  },
  "Risikogruppe IIb (Krallen-Hammerzehen)": {
    pair:   "Ein Paar Spezialschuhe bei Diabetischem Fußsyndrom mit diabetesadaptierter Fußbettung.",
    single: "Ein Spezialschuh bei Diabetischem Fußsyndrom mit diabetesadaptierter Fußbettung.",
  },
  "Risikogruppe IIb (dialysepflichtig)": {
    pair:   "Ein Paar Spezialschuhe bei Diabetischem Fußsyndrom mit diabetesadaptierter Fußbettung.",
    single: "Ein Spezialschuh bei Diabetischem Fußsyndrom mit diabetesadaptierter Fußbettung.",
  },
  "Risikogruppe III": {
    pair:   "Ein Paar Spezialschuhe bei Diabetischem Fußsyndrom mit diabetesadaptierter Fußbettung.",
    single: "Ein Spezialschuh bei Diabetischem Fußsyndrom mit diabetesadaptierter Fußbettung.",
  },
  "Risikogruppe IV": {
    pair:   "Ein Paar orthopädische Maßschuhe mit diabetesadaptierter Fußbettung.",
    single: "Ein orthopädischer Maßschuh mit diabetesadaptierter Fußbettung.",
  },
  "Risikogruppe V": {
    pair:   "Knöchelübergreifende orth. Maßschuhe mit DAF, Innenschuhe, Orthesen.",
    single: "Knöchelübergreifender orth. Maßschuh mit DAF, Innenschuh, Orthese.",
  },
  "Risikogruppe VI": {
    pair:   "Ein Paar orthop. Maßschuhe als Straßenschuhe, bds. diabetesadaptierte Fußbettung, Mittelfußrolle, Pufferabsatz, mit Sohlenversteifung, mit Stützlasche und Zehenersatz.",
    single: "Ein orthop. Maßschuh als Straßenschuh, diabetesadaptierte Fußbettung, Mittelfußrolle, Pufferabsatz, mit Sohlenversteifung, mit Stützlasche und Zehenersatz.",
  },
  "Risikogruppe VIIa": {
    pair:   "Ein Paar Verbandsschuhe; orthopädische Zurichtung mit Gegenausgleich.",
    single: "Ein Verbandsschuh; orthopädische Zurichtung mit Gegenausgleich.",
  },
  "Risikogruppe VIIb": {
    pair:   "Individuelle kniehohe Orthesen mit DAF und Kondülenführung.",
    single: "Individuelle kniehohe Orthese mit DAF und Kondülenführung.",
  },
  "Risikogruppe VIIc": {
    pair:   "Ein Paar nicht abnehmbare kniehohe Orthesen zur vollständigen Druckentlastung bei plantarer Läsion (außer Ferse), individuell angepasst.",
    single: "Eine nicht abnehmbare kniehohe Orthese zur vollständigen Druckentlastung bei plantarer Läsion (außer Ferse), individuell angepasst.",
  },
  "Risikogruppe VIId": {
    pair:   "Ein Paar nicht abnehmbare kniehohe individuelle Fersenentlastungsorthesen mit Kondylenführung und Reduktion axialer Kräfte.",
    single: "Eine nicht abnehmbare kniehohe individuelle Fersenentlastungsorthese mit Kondylenführung und Reduktion axialer Kräfte.",
  },
};

export const ZUSATZ_INFO = {
  "Risikogruppe VIIc": {
    zusaetze: [
      "Gewichtslimitierung und Herstellerangaben beachten.",
      "Passform muss sicher gewährleistet sein; andernfalls individuelle Orthese verordnen.",
      "Bei infizierter Ulzeration, AVK oder starker Exsudation nicht abnehmbare kniehohe Orthesen nur mit besonderer Vorsicht einsetzen; nach DDG sind abnehmbare Orthese beziehungsweise Verbandsschuh nachrangige Alternativen.",
      "Lokalisation und Seite der Läsion sowie gewünschte Entlastungszone auf dem Rezept beziehungsweise Verordnungsbogen ergänzen.",
    ],
    alternativen: [
      "Eine abnehmbare kniehohe Orthese zur Druckentlastung bei plantarer Läsion (außer Ferse), individuell angepasst; Diagnose: diabetisches Fußsyndrom, Risikogruppe VII c.",
      "Ein individueller Interimsschuh mit gezielter plantarer Druckentlastung und diabetesadaptierter Fußbettung; Diagnose: diabetisches Fußsyndrom, Risikogruppe VII c.",
      "Ein Total-Contact-Cast (TCC) zur vollständigen Druckentlastung einer plantaren Läsion außerhalb der Ferse; Diagnose: diabetisches Fußsyndrom, Risikogruppe VII c.",
      "Ein Paar Verbandsschuhe mit ausreichendem Volumen für Wundverband und gezielter Druckentlastung der Ulkusregion; Diagnose: diabetisches Fußsyndrom, Risikogruppe VII c.",
    ],
  },
  "Risikogruppe VIId": {
    zusaetze: [
      "Die Versorgung muss eine Kondylenführung und eine wirksame Reduktion axialer Kräfte gewährleisten.",
      "Konfektionierte Fersenentlastungsorthesen erfüllen laut DDG die erforderlichen Funktionsanforderungen nicht.",
      "Bei infizierter Ulzeration, AVK oder starker Exsudation nicht abnehmbare kniehohe Entlastungsvorrichtungen nur mit besonderer Vorsicht anwenden.",
      "Lokalisation, Seite, Ausmaß der Fersenläsion und erforderliche vollständige Druckentlastung auf der Verordnung dokumentieren.",
    ],
    alternativen: [
      "Ein Total-Contact-Cast (TCC) zur vollständigen Entlastung einer plantaren Fersenläsion; Diagnose: diabetisches Fußsyndrom, Risikogruppe VII d.",
    ],
  },
};

export function getSubVariantKey(typ, fussstatus = {}, fussstatusGrafik = {}, side) {
  const isLeft = side === "links";
  const {
    dialysepflichtigeNiereninsuffienz = "",
    linksPraeulzerativeVeranderungen = "",
    rechtsPraeulzerativeVeranderungen = "",
  } = fussstatus;
  const {
    plLeft = [], plRight = [],
    dorsLeft = [], dorsRight = [],
    medLeft = [], medRight = [],
    latLeft = [], latRight = [],
  } = fussstatusGrafik;

  const pl   = isLeft ? plLeft   : plRight;
  const dors = isLeft ? dorsLeft : dorsRight;
  const med  = isLeft ? medLeft  : medRight;
  const lat  = isLeft ? latLeft  : latRight;

  if (typ === "Typ IIb") {
    const praeulz    = (isLeft ? linksPraeulzerativeVeranderungen : rechtsPraeulzerativeVeranderungen) === "ja";
    const hasKrallen = [...pl, ...dors, ...med, ...lat].some(f => f.befund === "Krallen-/Hammerzehe");
    if (dialysepflichtigeNiereninsuffienz === "ja") return "Risikogruppe IIb (dialysepflichtig)";
    if (praeulz)    return "Risikogruppe IIb (Praeulzerative)";
    if (hasKrallen) return "Risikogruppe IIb (Krallen-Hammerzehen)";
    return "Risikogruppe IIb";
  }

  if (typ === "Typ VIIb") return "Risikogruppe VIIb";

  const typeMap = {
    "Typ I":    "Risikogruppe I",
    "Typ IIa":  "Risikogruppe IIa",
    "Typ III":  "Risikogruppe III",
    "Typ IV":   "Risikogruppe IV",
    "Typ V":    "Risikogruppe V",
    "Typ VI":   "Risikogruppe VI",
    "Typ VIIa": "Risikogruppe VIIa",
    "Typ VIIb": "Risikogruppe VIIb",
    "Typ VIIc": "Risikogruppe VIIc",
    "Typ VIId": "Risikogruppe VIId",
  };
  return typeMap[typ] || null;
}
